// Centralised site-wide configuration
export const SITE = {
  name: "Dégraissage Hotte Melun",
  legalName: "Dégraissage Hotte Melun",
  baseUrl: "https://degraissage-hotte-melun.fr", // canonical domain (à mettre à jour quand acheté)
  logo: "https://customer-assets.emergentagent.com/job_33c6de47-bfe8-4bf5-9649-2a26ed0179c3/artifacts/j8601ow7_Capture%20d%E2%80%99e%CC%81cran%202026-05-25%20a%CC%80%2022.24.01.png",
  phoneDisplay: "07 64 15 38 77",
  phoneTel: "+33764153877",
  email: "k.aberkane02@gmail.com",
  address: {
    street: "46 rue Lavoisier",
    postalCode: "77000",
    city: "Melun",
    region: "Île-de-France",
    country: "FR",
    countryName: "France",
    lat: 48.5418,
    lng: 2.6597,
  },
  hours: "Mo-Su 00:00-23:59", // 24/7
  hoursLabel: "7j/7 - 24h/24",
  founded: 2018,
  social: {},
};

export const HERO_IMAGES = {
  kitchen:
    "https://static.prod-images.emergentagent.com/jobs/33c6de47-bfe8-4bf5-9649-2a26ed0179c3/images/aebfd5c33d8bfc45a96e1cf49e8438a717e6b995ab3aa586bba9a34bbca64754.png",
  van:
    "https://static.prod-images.emergentagent.com/jobs/33c6de47-bfe8-4bf5-9649-2a26ed0179c3/images/7ee97483e7c00afd582954062eba25f708820d7e1aedf1d6dc7d03bde4e8302c.png",
  beforeAfter:
    "https://static.prod-images.emergentagent.com/jobs/33c6de47-bfe8-4bf5-9649-2a26ed0179c3/images/13d478efb3797af4e9e3c1ffd5c56bd49838069228978a4586f8223f9352bcfa.png",
  cleanKitchen:
    "https://images.unsplash.com/photo-1663790776711-9283bf614ac2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMHN0YWlubGVzcyUyMHN0ZWVsfGVufDB8fHx8MTc3OTc0MTA1OXww&ixlib=rb-4.1.0&q=85",
  chef:
    "https://images.pexels.com/photos/17086289/pexels-photo-17086289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cleaners:
    "https://images.pexels.com/photos/9462761/pexels-photo-9462761.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const TRUST_BADGES = [
  { label: "Intervention Rapide", icon: "Zap" },
  { label: "Hygiène & Sécurité", icon: "ShieldCheck" },
  { label: "Restaurants & Cuisines Pro", icon: "ChefHat" },
  { label: "Seine-et-Marne", icon: "MapPin" },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Diagnostic gratuit",
    desc: "Audit complet de votre hotte, gaines et système d'extraction avec rapport photo détaillé.",
  },
  {
    n: "02",
    title: "Devis transparent",
    desc: "Tarif clair, sans surprise, conforme à l'arrêté du 25 juin 1980 (sécurité incendie).",
  },
  {
    n: "03",
    title: "Intervention experte",
    desc: "Dégraissage professionnel haute pression, démontage des filtres, nettoyage des gaines.",
  },
  {
    n: "04",
    title: "Attestation officielle",
    desc: "Remise du certificat de dégraissage exigé par les assurances et les contrôles d'hygiène.",
  },
];

export const FAQ_GENERAL = [
  {
    q: "Pourquoi est-il obligatoire de faire dégraisser sa hotte de restaurant ?",
    a: "L'arrêté du 25 juin 1980 et le règlement sanitaire départemental imposent à tous les établissements de restauration un dégraissage régulier des hottes, filtres et gaines d'extraction. C'est une obligation légale, sanitaire et assurantielle pour prévenir les départs de feu et garantir l'hygiène en cuisine.",
  },
  {
    q: "À quelle fréquence faut-il dégraisser une hotte professionnelle ?",
    a: "La fréquence dépend de votre activité : 2 fois par an pour un restaurant traditionnel, 4 fois par an pour une cuisine intensive (friture, grillades, pizzeria). Les assurances exigent une attestation à jour pour couvrir un sinistre.",
  },
  {
    q: "Combien de temps dure une intervention de dégraissage de hotte ?",
    a: "Une intervention standard dure entre 2h et 4h selon la taille de la cuisine, l'encrassement et la longueur des gaines. Nous intervenons généralement de nuit ou tôt le matin pour ne pas perturber votre service.",
  },
  {
    q: "Que comprend votre prestation de dégraissage à Melun ?",
    a: "Démontage et nettoyage des filtres, dégraissage complet de la hotte (intérieur/extérieur), nettoyage des gaines d'extraction, vérification du moteur d'extraction, photos avant/après, et remise d'une attestation officielle conforme.",
  },
  {
    q: "Intervenez-vous en urgence sur Melun et Seine-et-Marne ?",
    a: "Oui, nous sommes joignables 7j/7 24h/24 au 07 64 15 38 77. Nous pouvons intervenir en urgence pour les contrôles d'hygiène, sinistres ou réouvertures rapides à Melun et dans toute la Seine-et-Marne (77).",
  },
  {
    q: "Délivrez-vous une attestation pour l'assurance ?",
    a: "Oui, chaque intervention donne lieu à la remise d'une attestation de dégraissage officielle, signée et datée, conforme aux exigences des assurances et des services d'hygiène (DDPP).",
  },
];
